import React, { useEffect, useState } from "react"
import Layout from "components/layout"
import SEO from "components/seo"
import Grid from "components/grid"
import ModalStore from "../../store/modal"
import { StaticImage } from "gatsby-plugin-image"
import Marquee from "react-fast-marquee"
import constants from "../../constants"
import Img from "gatsby-image"
import InlineVideo from "../../components/inline-video"
import RoundedBtn from "../../components/rounded-btn"
import SingleEccoLogo from "../../components/single-ecco-logo"
import DyptiqueSlideshow from "../../components/dyptique-slideshow"
import { graphql, useStaticQuery } from "gatsby"
import SwiperCore, { Navigation, Scrollbar } from 'swiper'
import ArrowIcon from "../../components/arrow-icon"
import { Swiper, SwiperSlide } from 'swiper/react'
import "swiper/swiper.scss"
import "swiper/components/scrollbar/scrollbar.scss"
import useDeviceVersion from "../../hooks/use-device-version"

// export const ss23_videoBasepath = `https://stella-luna-cms.s3.eu-west-3.amazonaws.com/ecco-ss23/`
export const ss23_videoBasepath = `https://eccocpeu.blob.core.windows.net/video/elu-ss23/`

SwiperCore.use([Navigation, Scrollbar])

const VideoSlider = ({
  videos,
  videosThumb,
  arrowBgColor,
  bgColor,
  info,
}) => {
  const [currentSliderIndex, setCurrentSliderIndex] = useState(1)
  const deviceVersion = useDeviceVersion();
  const [swiper, setSwiper] = useState(null)
  const openModal = index => {
    ModalStore.setModalVideo(videos[index], info[index], bgColor, arrowBgColor)
  }
  const onSlideChange = (e) => {
    setCurrentSliderIndex(e.activeIndex)
  }
  return (
    <div className="text-center pt-8 lg:pt-12 pb-16 md:max-w-screen-s lg:pb-10">
      <div
        className={`relative w-full h-full flex items-center justify-center`}
      >
        <div className="h-full w-full flex items-center justify-center">
          <div className="relative w-full h-full">
            <Swiper
              className={`w-full h-full ss23-swiper`}
              onSwiper={setSwiper}
              spaceBetween={deviceVersion === 'mobile' ? 10 : 30}
              centeredSlides={true}
              slidesPerView={'auto'}
              initialSlide={1}
              onSlideChange={onSlideChange}
              scrollbar={{
                el: '.index-swiper-scrollbar',
                dragClass: 'swiper-scrollbar-drag w-full h-full relative rounded-full left-0 top-0 bg-white',
                hide: false
              }}
            >
              {videos.map((video, index) => {
                return (
                  <SwiperSlide
                    key={`${index}-image-slide`}
                    className="w-full h-full"
                  >
                    <button
                      className="w-full h-full relative"
                      onClick={() => openModal(index)}
                    >
                      <Img
                        objectFit="cover"
                        alt=""
                        className={`w-full h-full`}
                        fluid={videosThumb[index].childImageSharp.fluid}
                      />
                      <div
                        className={`absolute z-10 w-full h-full top-0 left-0 flex justify-center items-center`}
                      >
                        <div className="w-2/12 lg:w-[3/12]">
                          <img src="/play-icon-circle.svg" />
                        </div>
                      </div>
                    </button>
                  </SwiperSlide>
                )
              })}
            </Swiper>
          </div>
        </div>
      </div>

      <div className="w-full flex items-center justify-center pt-4">
        <div className={`flex justify-between w-full lg:w-[60%]`}>
          <div className={`w-full text-center lg:text-left px-6 lg:px-0`}>
            {info[currentSliderIndex]}
          </div>
          <div className={`hidden lg:flex space-x-4`}>
            <button
              style={{ outline: 0 }}
              onClick={() => swiper.slidePrev()}
            >
              <ArrowIcon className={`transform rotate-180`} />
            </button>
            <button
              style={{ outline: 0 }}
              onClick={() => swiper.slideNext()}
            >
              <ArrowIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const SS23Landing = ({ location }) => {

  const [indexIsMini, setIndexIsMini] = useState(true);

  const data = useStaticQuery(graphql`
    fragment fluidImage2 on File { childImageSharp { fluid(maxWidth: 1920, quality:80, ) { ...GatsbyImageSharpFluid_withWebp_noBase64 } } }

    query {
      slider00thumb01: file(relativePath: { eq: "images/ss23/carousel-00/eric.jpg" }) { ...fluidImage2 }
      slider00thumb02: file(relativePath: { eq: "images/ss23/carousel-00/stefano.jpg" }) { ...fluidImage2 }
      slider00thumb03: file(relativePath: { eq: "images/ss23/carousel-00/lauren.jpg" }) { ...fluidImage2 }
    }
  `)

  const title3 = `text-[32px] lg:text-[68px] leading-none`
  const heroParagraph = `text-[16px] lg:text-[21px] leading-tight`
  const filepath2 = `../../../static/images/ss23/`
  const videoBasepath = ss23_videoBasepath

  const sliderVideos = [
    `${videoBasepath}mobile/ecco_ericjandar.mp4`,
    `${videoBasepath}mobile/ecco_stefanopillepich.mp4`,
    `${videoBasepath}mobile/ecco_laurenmcgonnigle.mp4`,
  ];
  const sliderVideosThumb = [
      data.slider00thumb01, data.slider00thumb02, data.slider00thumb03
  ];
  const sliderVideosTexts = [
      'Eric Jandar, Lead Designer Accessories',
      `Stefano Pillepich, Head of ECCO Leather Goods`,
      'Lauren McGonnigle, Category Manager',
  ]

  const strideContent = (
    <div className={`w-full lg:w-7/12 inline-block`}>
      <div className={`${title3} mb-6`}>
        STRIDE
      </div>
      <div
        className={`${heroParagraph}`}
      >
        Above: the ECCO Grooved Pinch Bag in Bleached Pink, which holds a structured embossed effect on leather, creating a grooved pattern. The 3D effect interacts with the light to give extra tactility and is made to awaken the senses.
        <br/><br/>
        ECCO Pot Bag Laces: a cool variation on the ECCO Pot Bag comes with laces like strings–a showcase piece made to swing vibrantly by your side while you stride.
      </div>
    </div>
  )

  const index1 = `1. ECCO Wave Street Tray, ECCO Wave Pinch Bag Full Size, ECCO Wave Pot Bag, ECCO Journey Pod Case all in Spice.`
  const index2 = (
    `2. ECCO Wave Pinch Bag Full Size in Spice, ECCO Wave Street Tray`
  )
  const index3 = `3. ECCO Wave Pot Bag in Night Ocean, ECCO Wave Street Tray`
  const index4 = `4. ECCO Pinch Bag Compact Wave in Night Ocean, ECCO Wave Street Tray`
  const index5 = `5. ECCO Pot Bag in First Tee, ECCO Textureblock Square Pack in Black`
  const index6 = `6. & 7. ECCO Pot Bag Family (various colours), ECCO Textureblock Phone Bag in Chilli Red, ECCO Textureblock Square Pack in Black, ECCO Textureblock Waist Bag in First Tee, ECCO Journey Pod Cases in First Tee and Chilli Red`
  const index8 = (
    `8. ECCO Grooved Pinch Bag in Bleached Pink`
  )
  const index9 = (
    `9. ECCO Pot Bag Laces`
  )
  const index10 = `10. ECCO Indigo Capsule, ECCO Indigo Phone Bag, ECCO Indigo Midi Pouch and ECCO Indigo Pinch Bag Mini`
  const index11 = `11. ECCO Wet Takeaway Crossbody, ECCO Pot Bag Wet both in Air`
  const index12 = `12. ECCO Water Phone Bag and ECCO Water Saddle Bag`
  const index13 = `13. ECCO Wave Scrunch Hobo`
  const index14 = `14. ECCO Pot Bag Family Textureblock Pot Bags in First Tee and Straw, ECCO Wave Pot Bag in Night Ocean, ECCO Pot Bag Double Indigo, ECCO Pot Bag Double Grooved in Bleached Pink`
  const index15 = `15. ECCO E Tote Stripe in Bright White / Neon Blue / Black, ECCO E Weekender Tote in Black and ECCO E Pot Bag Sling Monogram in Spice`
  const index16 = `16. ECCO E Weekender Tote in Air / Spice, ECCO E Tote in Spice`
  const index17 = `17. Select ECCO E Collection pieces: see previous images for names`
  const index18 = `18. ECCO E Pot Bag Sling Double E in Spice`
  const index19 = `19. ECCO E Phone Bag Stack Monogram in Air / Spice, ECCO E Phone Bag Stack Stripe in Bright White / Neon Blue / Black`
  const index20 = `20. ECCO E Pot Bag Sling Stripe in Bright White / Neon Blue / Black`

  const indexContent = (forceMaxContent) => {
    if (indexIsMini && !forceMaxContent) {
      return (
        <>
          <div className={`w-full lg:w-2/6`}>
            {index1}
            <br /><br />
            {index2}
          </div>
          <div className={`w-full lg:w-2/6 mt-5 lg:mt-0`}>
            {index3}
            <br /><br />
            {index4}
            <br /><br />
            {index5}
          </div>
          <button onClick={() => { setIndexIsMini(false) }} className="underline mt-10">See more</button>
        </>
      )
    } else {
      return (
        <>
          <div className={`w-full lg:w-2/6`}>
            {index1}
            <br /><br />
            {index2}
            <br /><br />
            {index3}
            <br /><br />
            {index4}
            <br /><br />
            {index5}
          </div>
          <div className={`w-full lg:w-2/6 mt-5 lg:mt-0`}>
            {index6}
            <br /><br />
            {index8}
            <br /><br />
            {index9}
            <br /><br />
            {index10}
            <br /><br />
            {index11}
          </div>
          <div className={`w-full lg:w-2/6 mt-5 lg:mt-0`}>
            {index12}
            <br /><br />
            {index13}
            <br /><br />
            {index14}
            <br /><br />
            {index15}
          </div>
          <div className={`w-full lg:w-2/6 mt-5 lg:mt-0`}>
            {index16}
            <br /><br />
            {index17}
            <br /><br />
            {index18}
            <br /><br />
            {index19}
            <br /><br />
            {index20}
          </div>
          <button onClick={() => { setIndexIsMini(true) }} className="underline mt-10 block lg:hidden">See less</button>
        </>
      )
    }
  }

  const downloadContent = (
    <>
      <div className="block mb-6">
        Feel free to download:
      </div>
      <div className="flex flex-col lg:flex-row lg:space-x-6 space-y-6 lg:space-y-0">
        <RoundedBtn
          href={`/images/ss23/ECCOLeatherGoods-SS23_PressRelease.pdf`}
          className={`border-[#FAE600] px-6 lg:px-6 py-5 lg:py-3 flex w-max lg:w-auto text-[23px]`}
        >Press Release</RoundedBtn>
        <RoundedBtn
          href={`/images/ss23/ECCOLeatherGoods-SS23_Lookbook.pdf`}
          className={`border-[#FAE600] px-6 lg:px-6 py-5 lg:py-3 flex w-max lg:w-auto text-[23px]`}
        >Lookbook</RoundedBtn>
      </div>
    </>
  )

  const eccoWaveButtonClasses = `text-[16px] text-[#00CDFF] border-2 lg:border-4 rounded-xl lg:rounded-3xl px-4 lg:px-5 py-3 lg:py-4 border-[#00CDFF] bg-[#0099DA] lg:text-[36px] leading-none inline-block`
  const eccoWaveButtonA = (
    <div className={`${eccoWaveButtonClasses}`}>ECCO Wave Pinch Bag Compact</div>
  )
  const eccoWaveButtonB = (
    <div className={`${eccoWaveButtonClasses}`}>ECCO Wave Street Tray</div>
  )
  const eccoWaveTitle = (
    <div className="uppercase text-[70px] lg:text-[160px] leading-none text-center text-white relative lg:-top-12 mb-20 lg:mb-0">ride the Wave</div>
  )

  return (
    <Layout location={location}>
      <SEO title={`SS23 Collection`} pathname={location.pathname} />

      <div className={`w-full h-full text-[#4F0D47] bg-[#FAE600] overflow-x-hidden`} id={`s0`}>

        <div
          className={`bg-[#B91E7D] text-[#FF8C0F] text-center w-full h-full lg:h-screen relative`}
          id={`s1`}
        >
          <div className={`w-full h-full`}>
            <div
              data-scroll
              data-scroll-target="#s1"
              data-scroll-speed="2"
              className={`relative w-full h-full flex justify-center items-center`}
            >
              <Grid className={`relative z-10 lg:h-[70vh] pt-36 lg:pt-0 pb-16 lg:pb-0`}>
                <div data-scroll data-scroll-speed="2.4" style={{ height: 'inherit' }} className="hidden lg:block col-start-2 col-span-4">
                  <StaticImage
                    src={`${filepath2}0-0.jpg`}
                    objectFit={`contain`}
                    alt={``}
                    className={`w-auto h-full`}
                  />
                </div>
                <div data-scroll data-scroll-speed="0.2" style={{ height: 'inherit' }} className="col-start-2 col-span-10 lg:col-start-8 lg:col-span-4">
                  <StaticImage
                    src={`${filepath2}0-1.jpg`}
                    objectFit={`contain`}
                    alt={``}
                    className={`w-auto h-full`}
                  />
                </div>
              </Grid>
              <div className="w-screen h-screen absolute animate-live-blink">
                <div className="bg-[#FAE600] w-[100vw] h-[100vw] lg:w-[53vw] lg:h-[53vw] blur-[15px] lg:blur-[25px] rounded-full absolute top-1/2 left-1/2 z-0 transform -translate-x-1/2 -translate-y-1/2"></div>
              </div>
            </div>
          </div>
          <div
            className={`w-full absolute h-full top-0 left-0 flex justify-center items-center text-[90px] lg:text-[210px] !leading-none`}
          >
            <div className="relative w-full h-full uppercase">
              <div
                data-scroll
                data-scroll-target="#s1"
                className={`absolute z-10 top-20 right-4 lg:right-auto lg:top-16 lg:left-6`}
              >
                Born
              </div>
              <div
                data-scroll
                data-scroll-target="#s1"
                className={`absolute z-10 top-1/2 left-6 lg:left-auto lg:right-12`}
              >
                To
              </div>
              <div
                data-scroll
                data-scroll-target="#s1"
                className={`absolute z-10 bottom-6 left-1/2 transform -translate-x-1/2`}
              >
                Move
              </div>
            </div>
          </div>
        </div>



        <div className={`w-full`}>
          <Marquee gradient={false} speed={50}>
            <div
              className={`bg-[#FAE600] text-[#B91E7D] text-[28px] lg:text-[60px] leading-none lg:leading-tight flex items-center pt-3 lg:pt-2 pb-4 lg:pb-4 whitespace-nowrap`}
            >
              <div>&nbsp;ECCO Leather Goods SS23 ⋅</div>
              <div>&nbsp;ECCO Leather Goods SS23 ⋅</div>
            </div>
          </Marquee>
        </div>



        <div className={`!bg-[#FF8C0F] w-full text-center relative`}>
          <div
            className={`px-8 lg:px-0 w-full lg:w-10/12 text-[32px] lg:text-[80px] leading-[1.1] mx-auto pt-16 pb-16 lg:pt-32 lg:pb-36`}
          >
            Our latest season is infused with a vibrancy and energy that comes directly from the people that wear us. When we move, like them, we move big.
          </div>
        </div>



        <div>
          <InlineVideo
            src={`ECCO_VIDEO_ECOWAVE.mp4`}
            basepath={videoBasepath}
            className={`w-full text-[#FF8C0F]`}
            hasSound={true}
          />
        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32`}
        >
          <Grid className={``}>
            <div className={`col-span-full`}>
              <StaticImage
                src={`${filepath2}2-0.jpg`}
                alt={``}
              />
              <div className={`${constants.caption} pt-3`}>3</div>
            </div>
            <div className={`col-span-full lg:col-start-7 lg:col-span-5 pt-10 lg:pt-0`}>
              <div className={`${title3} mb-6 mt-6`}>
                RIDE THE WAVE
              </div>
              <div>
                This season we ride the ECCO Wave print. It creates waves throughout the collection and stands-out everywhere from shoes – the ECCO Wave Street Tray, all the way to our visual brand world and identity. It is crafted on our rich leather collections through embossing and brings the energetic Spring/Summer vibe alive.
              </div>
            </div>
          </Grid>

        </div>


        <div
          className={`w-full relative`}
        >
          <Grid className={`h-full`}>

            <div
              className={`lg:hidden px-6 pt-32 pb-6 col-span-full`}
              style={{ backgroundImage: `url(/images/ss23/3-1.jpg)`, backgroundSize: 'cover' }}
            >
              <div className="w-full flex justify-center items-center">
                {eccoWaveTitle}
              </div>
              <div className="space-y-2">
                {eccoWaveButtonA}
                {eccoWaveButtonB}
              </div>
            </div>


            <div className={`hidden lg:block col-span-full lg:col-span-6 h-full relative`}>
              <div className="relative z-0 w-full h-full">
                <StaticImage
                  src={`${filepath2}3-1.jpg`}
                  objectFit={`cover`}
                  alt={``}
                  className={`w-auto h-full`}
                />
              </div>
              <div className={`absolute w-full h-full z-10 top-0`}>
                <div data-scroll data-scroll-speed="0.8" className="w-full h-full flex justify-center items-center px-6">
                  {eccoWaveTitle}
                </div>
                <div className="absolute bottom-8 left-6 lg:left-8 space-y-4">
                  {eccoWaveButtonA}
                  {eccoWaveButtonB}
                </div>
              </div>
            </div>

            <div className={`col-span-full lg:col-span-6 relative`}>
              <div className="relative z-0 w-full h-full">
                <StaticImage
                  src={`${filepath2}3-0.jpg`}
                  alt={``}
                />
              </div>
              <div className={`absolute w-full h-full z-10 top-0 left-0`}>
                <div  data-scroll data-scroll-speed="-0.8" className="w-full h-full flex justify-center items-center px-6">
                  <SingleEccoLogo
                    className={`fill-white w-9/12`}
                  />
                </div>
                <div className={`${constants.caption} absolute bottom-4 left-4`}>4</div>
              </div>
            </div>
          </Grid>

        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32 bg-[#FF8C0F]`}
        >
          <Grid className={``}>
            <div data-scroll data-scroll-speed="1" className={`col-span-full`}>
              <StaticImage
                src={`${filepath2}4-0.jpg`}
                alt={``}
              />
              <div className={`${constants.caption} pt-3`}>5</div>
            </div>
          </Grid>

          <Grid className={`h-full pt-10`}>
            <div data-scroll data-scroll-speed="2.4" className={`col-start-1 col-end-9 lg:col-end-7`}>
              <StaticImage
                src={`${filepath2}4-1.jpg`}
                alt={``}
              />
              <div className={`${constants.caption} pt-3`}>6</div>
            </div>
            <div
              className={`col-start-1 lg:col-start-7 col-end-13 h-full flex justify-center items-center mt-6 lg:mt-0`}
            >
              <div className={`w-full lg:w-7/12 inline-block`}>
                <div className={`${title3} mb-6`}>
                  UNITE
                </div>
                <div
                  className={`${heroParagraph}`}
                >
                  Everything made to connect the dots in people’s lives and be there as you network, hang out, or explore the next place you want to be seen at. Featuring here the ECCO Pot Bag First Tee, and the ECCO Textureblock Square Pack in black, with more essential modular pieces for people to combine and wear as they choose now or in their future.
                </div>
              </div>
            </div>
          </Grid>

        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32`}
        >
          <InlineVideo
            src={`ECCO_VIDEO_GOOD.mp4`}
            basepath={videoBasepath}
            className={`w-full text-[#00CDFF]`}
            hasSound={true}
          />
        </div>


        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32`}
          style={{ backgroundImage: `url(/images/ss23/6-1.jpg)`, backgroundSize: 'cover' }}
        >
          <div data-scroll data-scroll-speed="1.4" className="relative w-full h-full">
            <StaticImage
              src={`${filepath2}6-0.jpg`}
              alt={``}
              className={`relative z-0`}
            />
            <div className={`${constants.caption} z-10 absolute bottom-4 left-4`}>7</div>
          </div>

        </div>



        <div
          className={`w-full relative`}
        >
          <Grid className={`h-full`}>
            <div className={`col-span-full lg:col-span-6 h-full relative`}>
              <div className="relative z-0 w-full h-full">
                <StaticImage
                  src={`${filepath2}7-0.jpg`}
                  objectFit={`cover`}
                  alt={``}
                  className={`w-auto h-full`}
                />
              </div>
              <div className={`${constants.caption} z-10 absolute bottom-4 left-4`}>8</div>
            </div>
            <div className={`col-span-full lg:col-span-6 relative`}>
              <div className="relative z-0 w-full h-full">
                <StaticImage
                  src={`${filepath2}7-3.jpg`}
                  alt={``}
                />
              </div>
              <div className={`absolute w-full h-full z-10 top-0 left-0`}>
                <div data-scroll data-scroll-speed="0.8" className="w-full h-full flex justify-center items-center px-6">
                  <SingleEccoLogo
                    className={`fill-[#FF8C0F] w-9/12`}
                  />
                </div>
              </div>
            </div>
          </Grid>

        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32 bg-[#E3AFE1]`}
        >

          <Grid className={`h-full pt-0 lg:pt-10`}>

            <div className={`hidden col-start-1 col-end-7 h-full lg:flex justify-center items-center`}>
              { strideContent }
            </div>

            <div
              className={`col-start-5 lg:col-start-7 col-end-13`}
              data-scroll data-scroll-speed="1.8"
            >
              <StaticImage
                src={`${filepath2}7-1.jpg`}
                alt={``}
              />
              <div className={`${constants.caption} pt-3`}>9</div>
            </div>

            <div className={`flex col-span-full h-full lg:hidden mt-10`}>
              { strideContent }
            </div>

          </Grid>

        </div>


        <div
          className={`w-full`}
        >
          <InlineVideo
            src={`ECCO_VIDEO_BETTER.mp4`}
            basepath={videoBasepath}
            className={`w-full text-[#FF8C0F]`}
            hasSound={true}
          />
        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32 bg-[#FF8C0F]`}
        >

          <Grid className={`h-full pt-0 lg:pt-10`}>
            <div data-scroll data-scroll-speed="1.8" className={`col-start-1 lg:col-start-2 col-end-8`}>
              <StaticImage
                src={`${filepath2}8-0.jpg`}
                alt={``}
              />
              <div className={`${constants.caption} pt-3`}>10</div>
            </div>
            <div
              className={`col-start-1 lg:col-start-8 col-end-13 h-full flex justify-center items-center mt-8 lg:mt-0`}
            >
              <div className={`w-full lg:w-8/12 inline-block`}>
                <div className={`${title3} mb-6`}>
                  SHINE
                </div>
                <div
                  className={`${heroParagraph}`}
                >
                  The Indigo Leather Capsule this season uses this intense natural pigment and ancient technique to create the unique shiny light-blue color. It is inspired by denim, to evolve over time and wear, while the way it’s dyed highlights the uniqueness of each skin. Featuring the ECCO Indigo Midi Pouch, ECCO Indigo Phone Bag, and ECCO Indigo Pinch Bag Mini. Made to be worn and clipped together in any combo required.
                </div>
              </div>
            </div>
          </Grid>

        </div>



        <div
          className={`w-full relative`}
        >
          <Grid className={`h-full`}>
            <div className={`col-span-full lg:col-span-6 relative`}>
              <div className="relative z-0 w-full h-full">
                <StaticImage
                  src={`${filepath2}9-0.jpg`}
                  alt={``}
                />
              </div>
              <div className={`absolute w-full h-full z-10 top-0 left-0`}>
                <div data-scroll data-scroll-speed="0.8" className="w-full h-full flex justify-center items-center px-6">
                  <SingleEccoLogo
                    className={`fill-[#4F0D47] w-9/12`}
                  />
                </div>
                <div className={`w-full h-full text-[#4F0D47] absolute z-10 top-0 flex justify-center items-end text-center`}>
                  <div className="px-6 lg:px-0 w-full lg:w-7/12 pb-8 lg:pb-16">
                    Walk on air with this special leather experience. Introducing an ultra-shine innovation, inspired by water and this season in the Air colorway. Featuring the the ECCO Wet Takeaway Crossbody and ECCO Pot Bag Wet.
                  </div>
                </div>
              </div>
            </div>
            <div className={`col-span-full lg:col-span-6 h-full relative`}>
              <div className="relative z-0 w-full h-full">
                <StaticImage
                  src={`${filepath2}9-1.jpg`}
                  objectFit={`cover`}
                  alt={``}
                  className={`w-auto h-full`}
                />
              </div>
              <div className={`${constants.caption} z-10 absolute bottom-4 left-4`}>11</div>
            </div>
          </Grid>

        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32 bg-[#00CDFF]`}
        >
          <Grid className={``}>
            <div className={`col-span-full relative`}>
              <StaticImage
                src={`${filepath2}9-2.jpg`}
                alt={``}
              />
              <div className={`${constants.caption} pt-0 lg:pt-3 absolute lg:static bottom-4 left-4`}>12</div>
            </div>
            <div className={`col-start-1 lg:col-start-7 col-span-full lg:col-span-5 mt-6 lg:mt-0`}>
              <div className={`${title3} mb-6`}>
                FLOW
              </div>
              <div>
                A striking water colour print is made by hand, converted to artwork and then digitally printed on leather. Inspired by water droplets, it features this season on the ECCO Water Phone Bag and the ECCO Water Saddle Bag.
              </div>
            </div>
          </Grid>

        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32 bg-[#C8D94C]`}
        >
          <Grid className={``}>
            <div className={`col-span-full`}>
              <DyptiqueSlideshow
                slides={[
                  <StaticImage src={`${filepath2}10-1.jpg`} alt={``} />,
                  <StaticImage src={`${filepath2}10-2.jpg`} alt={``} />,
                  <StaticImage src={`${filepath2}10-3.jpg`} alt={``} />,
                  <StaticImage src={`${filepath2}10-4.jpg`} alt={``} />,
                  <StaticImage src={`${filepath2}10-5.jpg`} alt={``} />,
                  <StaticImage src={`${filepath2}10-6.jpg`} alt={``} />,
                  <StaticImage src={`${filepath2}10-7.jpg`} alt={``} />,
                  <StaticImage src={`${filepath2}10-8.jpg`} alt={``} />
                ]}
              />
              <div className={`${constants.caption} pt-3`}>13</div>
            </div>
            <div className={`col-start-1 lg:col-start-7 col-span-full lg:col-span-5 mt-6 lg:mt-0`}>
              <div>
                The ECCO Wave pattern also features this season as a trend textile jacquard on the ECCO Wave Scrunch Hobo, made from recycled yarn it has energizing green neon accents on a darker background.
              </div>
            </div>
          </Grid>

        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-20 lg:pb-32 bg-[#E3AFE1]`}
        >

          <Grid className={`h-full pt-0 lg:pt-10`}>
            <div data-scroll data-scroll-speed="1.8" className={`col-start-1 lg:col-start-2 col-end-9 lg:col-end-8`}>
              <StaticImage
                src={`${filepath2}11-0.jpg`}
                alt={``}
              />
              <div className={`${constants.caption} pt-3`}>14</div>
            </div>
            <div
              className={`col-start-1 lg:col-start-8 col-end-13 h-full flex justify-center items-center mt-8 lg:mt-0`}
            >
              <div className={`w-full lg:w-8/12 inline-block`}>
                <div className={`${title3} mb-6 w-10/12 lg:w-full`}>
                  THE FUTURE IS IN THE POT BAG
                </div>
                <div
                  className={`${heroParagraph}`}
                >
                  One of our most iconic and popular bags. Designed to give you all the space you need, as you connect them up, add essentials, and go. The more the better. Featuring the Textureblock Pot Bags in First Tee and Straw: with different ultra-tactile smooth to pebbled textures in one bag. Also featuring the ECCO Wave Pot Bag in Night Ocean, from the Summer Indigo capsule the ECCO Pot Bag Double Indigo, and the ECCO Pot Bag Double Grooved in Bleached Pink.
                </div>
              </div>
            </div>
          </Grid>

        </div>


        <div className={`bg-[#4F0D47] w-full text-center relative text-[#FAE600]`}>
          <Grid className={`pt-16 lg:pt-32 pb-16 lg:pb-20`}>
            <div
              className={`col-start-2 lg:col-start-4 col-end-12 lg:col-end-10 h-full flex flex-col justify-center items-center space-y-8`}
            >
              <div className={`w-11/12 lg:w-11/12`}>
                <img src="/images/ss23/ecco-e-collection.svg" alt=""/>
              </div>
              <div className={`w-full`}>
                <div
                  className={`${heroParagraph} text-[21px]`}
                >
                  The entire ECCO E collection is born from our heritage, reimagined for the future with a futuristic and organic shaped logo with two mirrored E letters derived from the brand’s 60s archival font. It stars our ECCO E Totes, made in a variety of sizes, leather and colorways.
                </div>
              </div>
            </div>
          </Grid>
        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32`}
          style={{ backgroundImage: `url(/images/ss23/12-1.jpg)`, backgroundSize: 'cover' }}
        >
          <Grid>
            <div data-scroll data-scroll-speed="1.8" className="col-start-2 lg:col-start-3 col-span-10 lg:col-span-8 relative">
              <StaticImage
                src={`${filepath2}12-0.jpg`}
                alt={``}
                className={`relative z-0`}
              />
              <div className={`${constants.caption} z-10 absolute bottom-4 left-4`}>15</div>
            </div>
          </Grid>

        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-12 lg:pt-32 pb-12 lg:pb-32 bg-[#4F0D47] text-[#FAE600]`}
        >
          <Grid className={``}>
            <div className={`col-span-full mb-10 lg:mb-16`}>
              <InlineVideo
                src={`ECCO_VIDEO_BEST.mp4`}
                basepath={videoBasepath}
                className={`w-full text-[#4F0D47]`}
                hasSound={true}
              />
            </div>
            <div className={`col-start-1 col-span-full lg:col-span-4 mb-6 lg:mb-0`}>
              <div className={`text-[26px] lg:text-[52px] leading-none`}>
                Atelier Of The Future
              </div>
            </div>
            <div className={`col-start-1 lg:col-start-7 col-span-full lg:col-span-5 space-y-10 lg:space-y-8`}>
              <div>
                A walk through our leather atelier of the future as we show the sheer amount of leather, art, innovation and craft that goes into each and every bag. Made in-house; we carry everything needed to make the carry-alls people use in their lives. Starring the ECCO E Tote Stripe.
              </div>
              <RoundedBtn
                to={`/about`}
                className={`border-[#FAE600] px-10 lg:px-6 py-6 lg:py-3 flex w-auto text-[23px]`}
              >Discover Our Atelier</RoundedBtn>
            </div>
          </Grid>

        </div>


        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32 bg-[#FF8C0F]`}
        >
          <Grid>
            <div data-scroll data-scroll-speed="1.8" className="col-start-1 lg:col-start-3 col-span-full lg:col-span-8 relative">
              <StaticImage
                src={`${filepath2}14-0.jpg`}
                alt={``}
                className={`relative z-0`}
              />
              <div className={`${constants.caption} pt-3`}>16</div>
              <div className={`pt-6 lg:pt-3 w-full flex justify-end`}>
                <div className="w-full lg:w-6/12 max-w-[330px]">
                  The ECCO E Tote comes in a variety of seasonal colorways, all starring our bold iconic E up front.
                </div>
              </div>
            </div>
          </Grid>

        </div>



        <div className="relative w-full">
          <StaticImage
            src={`${filepath2}14-1.jpg`}
            alt={``}
          />
          <div className={`${constants.caption} z-10 absolute bottom-4 left-4`}>17</div>
        </div>


        <div
          className={`w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32 bg-[#4F0D47] text-[#FAE600]`}
        >
          <Grid>
            <div data-scroll data-scroll-speed="1.8" className="col-start-1 lg:col-start-3 col-span-full lg:col-span-8 relative">
              <StaticImage
                src={`${filepath2}15-0.jpg`}
                alt={``}
                className={`relative z-0`}
              />
              <div className={`${constants.caption} pt-3`}>18</div>
              <div className={`pt-6 lg:pt-3 w-full flex justify-end text-right`}>
                <div className="w-11/12 lg:w-6/12 max-w-[330px]">
                  ECCO E Pot Bag. Made in ECCO Leather's iconic Pegasus leather.
                </div>
              </div>
            </div>
          </Grid>

        </div>



        <div
          className={`w-full relative bg-[#FF8C0F]`}
        >
          <Grid className={`h-full`}>
            <div className={`col-span-full lg:col-span-6 relative`}>
              <div className="relative z-0 w-full h-full">
                <StaticImage
                  src={`${filepath2}16-0.jpg`}
                  alt={``}
                />
                <div className={`${constants.caption} z-10 absolute bottom-4 left-4`}>19</div>
              </div>
            </div>
            <div className={`col-span-full lg:col-span-6 h-full relative flex justify-center items-center py-12 lg:py-0`}>
              <div data-scroll data-scroll-speed="0.6" className={`px-10 lg:px-0 w-full lg:w-9/12 relative`}>
                <div className="relative z-0 w-full h-full">
                  <StaticImage
                    src={`${filepath2}16-1.jpg`}
                    objectFit={`cover`}
                    alt={``}
                  />
                  <div className={`${constants.caption} pt-3`}>20</div>
                  <div className="w-full static lg:absolute text-right pt-3 lg:pt-0">
                    TIME TO REFLECT
                  </div>
                </div>
              </div>
            </div>
          </Grid>

        </div>



        <div
          className={`!leading-tight pt-16 lg:pt-36 pb-20 lg:pb-36 flex flex-col lg:flex-row w-full`}
        >
          <div className={`w-full lg:w-5/12 mb-6 lg:mb-0`}>
            <div className={`px-6 lg:px-10 text-[50px] lg:text-[54px]`}>— Index</div>
          </div>
          <div className={`relative lg:static left-2/12 w-10/12 lg:w-11/12 flex pl-3 lg:pl-0 pr-6 lg:pr-0`}>
            <div className={`px-0 lg:px-10`}>
              <div className="hidden lg:flex gap-0 lg:gap-8">{ indexContent(true) }</div>
              <div className="block lg:hidden">{ indexContent() }</div>
            </div>
          </div>
        </div>



        <div
          className={`w-full px-6 lg:px-10 relative pt-12 lg:pt-32 pb-12 lg:pb-24 bg-[#4F0D47] text-[#FAE600]`}
        >
          <Grid className={``}>

            <div className={`col-start-1 col-span-full lg:col-span-4`}>
              <div className={`text-[26px] lg:text-[52px] leading-tight mb-12 lg:mb-28`}>
                Spring/Summer 2023 Collection
                <div className="inline-block lg:block pl-2 lg:pl-0">BORN TO MOVE</div>
              </div>
            </div>

            <div className="hidden lg:block col-start-1 col-span-4 absolute bottom-28">
              { downloadContent }
            </div>

            <div className={`col-start-3 lg:col-start-7 col-span-10 lg:col-span-6 lg:flex lg:space-x-6`}>
              <div className="flex-1">
                ECCO’s latest season is infused with a vibrancy and energy that comes directly from the people that wear us. When we move, like them, we move big. They will carry us by their side and we, in turn, provide everything at-hand when needed. Their side-kick companions. For the first time this season, we pair accessories with shoes within our brand collateral to create one unified offering. Walk with us through our latest pioneering season.
                <div className="w-full h-8 lg:h-10 block" />
                <span className="inline-block">PART OF YOUR JOURNEY</span>
                <br/>
                The movement we see in the video campaign and imagery is both physical and mental, as we ‘walk-the-walk’ side-by-side for those we design for—and help them live their lives as comfortably and high-vibration as ever.
              </div>
              <div className="flex-1 mt-8 lg:mt-0">
                <span className="inline-block">BRIGHT CONNECTIONS</span>
                <br/>
                This season once again sees unusual color pairings that seem like they should clash yet work together perfectly. Bright ideas come to life in colors like Spice, Air, Bright White, and carrying over from AW22, the vibrant Berry Sorbet.
              </div>
              <div className="lg:hidden mt-16">
                { downloadContent }
              </div>
            </div>

          </Grid>

        </div>


        <div
          className={`w-full relative pt-12 lg:pt-32 pb-12 lg:pb-26 bg-[#E3AFE1]`}
        >
          <Grid className={``}>

            <div className={`col-start-2 lg:col-start-4 col-span-10 lg:col-span-6 text-center space-y-8`}>
              <div className={`${title3} lg:uppercase`}>
                Stories
              </div>
              <div className={`px-6 lg:px-12`}>
                A space to discover inspiring stories from the world of our SS23 season. Including our values, futuristic craftsmanship, collections and more.
              </div>
            </div>

            <div className="col-span-full">
              <div className={``}>
                <VideoSlider
                  arrowColor="#ffffff"
                  arrowBgColor="#ffffff"
                  bgColor="#E3AFE1"
                  videos={sliderVideos}
                  videosThumb={sliderVideosThumb}
                  playColor="#ffffff"
                  info={sliderVideosTexts}
                />
              </div>

            </div>
          </Grid>

        </div>


        <div
          className={`hidden lg:block w-full px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32`}
          style={{ backgroundImage: `url(/images/ss23/18-0.jpg)`, backgroundSize: 'cover' }}
        >
          <Grid>
            <div data-scroll data-scroll-speed="1.8" className="col-start-2 lg:col-start-4 col-span-10 lg:col-span-6 relative px-14">
              <InlineVideo
                src={`ELU-SS23.mp4`}
                basepath={videoBasepath}
                className={`w-full text-[#FF8C0F]`}
                hasSound={true}
              />
            </div>
          </Grid>

        </div>

        <div
          className={`w-full lg:hidden px-6 lg:px-10 relative pt-16 lg:pt-32 pb-16 lg:pb-32`}
          style={{ backgroundImage: `url(/images/ss23/18-1.jpg)`, backgroundSize: 'cover' }}
        >
          <Grid>
            <div data-scroll data-scroll-speed="1.8" className="col-span-full">
              <InlineVideo
                src={`ELU-SS23.mp4`}
                basepath={videoBasepath}
                className={`w-full text-[#FF8C0F]`}
                hasSound={true}
              />
            </div>
          </Grid>

        </div>


      </div>
    </Layout>
  )
}

export default SS23Landing
